import styled from 'styled-components';

export default styled.div`
  && {
    background-color: white;
    .export-csv-cpap {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      background-color: #ecffb8;
      padding: 15px 60px;
      .btn-output {
        background-color: #a956ea;
        color: white;
        height: 35px;
        width: 182px;
        border-radius: 5px;
        border: none;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
        margin-left: 20px;
      }
    }
    .section {
      padding: 25px 40px;
      .table {
        margin-top: 40px;
      }
    }
    @media screen and (max-width: 844px) {
      .section {
        padding: 25px 10px;
        .table {
          colgroup col:last-child,
          .ant-table-thead tr th:last-child,
          .ant-table-tbody tr td:last-child {
            display: none;
          }
          .ant-table-tbody td {
            padding: 12px 4px;
            line-height: 1.2;
            letter-spacing: 0;
            &:last-child {
              font-size: 9px;
            }
          }
        }
      }
    }
  }
`;
